﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { GreenStickerPlan, GSPToken, DPHDayToken, DailyToken, DailyTokenItem, GSPDayToken, Plan, MSCToken, MaterialShortage, MSCDayToken, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {trigger, transition, style, animate, state} from '@angular/animations';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-grn-stic-plan',
  templateUrl: './grn-stic-plan.component.html',
  styleUrls: ['./grn-stic-plan.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
        ':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', 'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({transform: 'translateX(0)', 'opacity': 1}),
          animate('500ms', style({transform: 'translateX(100%)', 'opacity': 0})
          
          )]
      )]
    )
  ]
})
export class GrnSticPlanComponent implements OnInit {

  editToken: string = '';
  editHeader: string = '';
  editText: string = '';
  editType: string = '';
  editParam1: any;
  editParam2: any;
  moduleKeyName: string = "grn_stic_plan";
  currMonthDtObj: Date = new Date();

  shortageFlag:boolean = false;
  severityFlag:boolean = false;
  isNewRecord:boolean = false;
  editRow: GSPToken;


  greenSticPlanMonthly: GreenStickerPlan;
  dGSPDayTokenObj: GSPDayToken;


  isLoading: boolean = false;
  isLoaded: boolean = false;
  isFailed: boolean = false;
  failMessage: string = '';

  selView: number = 1;
  areChangesMade: boolean = false;
  prevValue:string = 'no';

  planObj: Plan;
  btnName: string = '';
  mId: string = "6e333b36-7125-4c4f-0445-0af4d51397f8";
  hasmodaccess: boolean = false;
  daywiseItemList: Array<DailyToken>;

  @ViewChild('childModal') public childModal: ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(private _dataService: DataService,
    private _activatedRoute: ActivatedRoute, private _notify: NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Green Sticker Plan Highlights";

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['month']) {
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
      this.loadPlan();
    });
  }

  checkModAccess(): boolean {
    if (this._dataService.mAccess(this.mId) == true) {
      this.hasmodaccess = true;
    }
    else {
      this.hasmodaccess = false;
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }
  hasReadAccess(_pid: string) {
    return this._dataService.hasReadAccess(this.mId, _pid);
  }

  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  // shortageChanged(val) {
  //   if (val == 'yes') {
  //     this.loadShortageData();
  //   }
  // }
  // loadShortageData() {
  //   if (this.editRow.isShortageLoaded == false) {
  //     this._dataService.loadShortageData(this.editRow.materialShortageIds).subscribe((_msArray: Array<MSCToken>) => {
  //       this.editRow.materialShortageData = _msArray;
  //     })
  //   }
  // }
  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadGreenStickerPlan(this.currMonthDtObj).subscribe((_cstInspPlan: GreenStickerPlan) => {
      if (_cstInspPlan != null) {
        this.greenSticPlanMonthly = _cstInspPlan;
        this.loadDateData();

        let _tmpDailyTokenList: Array<DailyToken> = [];
        for (var i = 0; i < this.greenSticPlanMonthly.dayTokens.length; i++) {
          let _tmpDate: Date = this.greenSticPlanMonthly.dayTokens[i].selDate;
          let _tmpDailyTokens: Array<DailyTokenItem> = [];

          let _indexer: number = 0;
          this.greenSticPlanMonthly.dayTokens[i].dateTokens.forEach((_tmpObj: GSPToken) => {
            _tmpDailyTokens.push(new DailyTokenItem(this.getDisplayTokenName(_tmpObj.customerName, _tmpObj.quantity), this.getIdObj(_tmpDate, _indexer), ''));
            _indexer++;
          });
          _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
        }

        this.daywiseItemList = _tmpDailyTokenList;
        this.isLoaded = true;
        this.isLoading = false;
        this.isFailed = false;
      }
      else {
        this.daywiseItemList = null;
        this.isLoaded = false;
        this.isLoading = false;
        this.isFailed = true;
        this.failMessage = "Failed to get data from database, try again";
      }
    });
  }

  private getDisplayTokenName(_prodId: string, _quantity: number) {
    return this._dataService.getCustomerName(_prodId) + ' (' + _quantity + ')';
  }
  private getIdObj(_selDate: Date, _itemIndex: number) {
    return { "selDate": _selDate, "rowIndex": _itemIndex }
  }
  ItemSelected(_evntObj) {
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public showChildModal(_editToken: string, _param1: any, _param2: any): void {
    switch (_editToken) {
      case "rowedit":
        this.btnName = "Done";
        this.editRow = _param1.cloneSelf();
        this.isNewRecord = false;
        this.prevValue = this.editRow.shortage;
        if (this.editRow.shortage == 'yes') {
          this.severityFlag = true;
          this.shortageFlag = false;
        }else{
          this.severityFlag = false;
          this.shortageFlag = false;
        }
        this.editType = _editToken;
        this.editHeader = "Edit Green Sticker Plan (" + this.formatHeaderDate(this.dGSPDayTokenObj.selDate) + ")";
        break;
      case "rownew":
        this.btnName = "Done";
        this.isNewRecord = true;        
        this.severityFlag = false;
        this.shortageFlag = false;
        this.editRow = new GSPToken(GenService.getGUID(), null,null, null, 0, null,null,null,(new Date()).getTime(),null);
        this.editType = _editToken;
        this.editHeader = "Add Green Sticker Plan (" + this.formatHeaderDate(this.dGSPDayTokenObj.selDate) + ")";
        break;
      case "selplan":
        this.btnName = "Save";
        this.editText = this.planObj.description;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
        break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  dataEdited() {
    if (this.validateData) {
      switch (this.editToken) {
        case "rowedit":
          this.editParam1.productName = this.editRow.productName;
          this.editParam1.productType = this._dataService.getProductTypeBasedOnProductId(this.editRow.productName)
          this.editParam1.customerName = this.editRow.customerName;
          this.editParam1.quantity = this.editRow.quantity;
          this.editParam1.shortage = this.editRow.shortage;
          // this.editParam1.materialShortageIds = this.editRow.materialShortageIds;
          // this.editParam1.materialShortageData = this.editRow.materialShortageData;
          this.editParam1.status = this.editRow.status;
          this.editParam1.shortageNotes = this.editRow.shortageNotes;
          this.editParam1.creationDate = this.editRow.creationDate;
          this.editParam1.severityValue = this.editRow.severityValue
          break;
        case "rownew":
          let _tempShortageIds = [];
          let _newToken:GSPToken = new GSPToken(this.editRow.rowId, this.editRow.productName,this._dataService.getProductTypeBasedOnProductId(this.editRow.productName), this.editRow.customerName,
          this.editRow.quantity, this.editRow.shortage,this.editRow.status,this.editRow.shortageNotes,this.editRow.creationDate,this.editRow.severityValue);
          // _newToken.materialShortageData = this.editRow.materialShortageData;
          this.greenSticPlanMonthly.addDateToken(new Date(this.currMonthDtObj),_newToken);
          break;
        case "selplan":
          this.greenSticPlanMonthly.plan = this.editText;
          this.planObj.description = this.editText;
          this.planObj.monthDateNum = this.currMonthDtObj.getTime();
          this.savePlan();
          break;
      }
      this.areChangesMade = true;
      this.hideChildModal();
    }
  }
  loadPlan() {
    this._dataService.loadPlan(this.currMonthDtObj).subscribe((_dailyProdHigh: Plan) => {
      if (_dailyProdHigh != null) {
        this.planObj = _dailyProdHigh;
      }
    });
  }
  savePlan() {
    this._dataService.savePlan(this.planObj).subscribe((resp: GenResponse) => {
        if (resp.status == DataService.statusFail) {
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else {
          this._notify.success('Success', resp.details, this._dataService.successOptions);
          this.loadMonthData();
          this.loadPlan();
        }

      });
  }
  formatHeaderDate(_date: Date): string {
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getStatus(_id:string):string{
    if(_id == "forwarded"){
      return "Forwarded";
    }
    if(_id)
      return this._dataService.getRecordStatus(_id)
    return '';
  }
  getCustomerName(_custId: string): string {
    if (_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getShortage(_custId: string): string {
    if (_custId)
      return this._dataService.getShortage(_custId);
    return '';
  }
  getData(option) {
    if (option) return option
    return ''
  }

  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    } else {
      return null;
    }
  }
  prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  prevDateSel(): void {
    if (this.currMonthDtObj.getDate() > 1) {
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate() - 1);
      this.loadDateData();
    }
  }
  nextDateSel(): void {
    var _tmpLastDayOfMonth: Date = new Date(this.currMonthDtObj.getFullYear(), this.currMonthDtObj.getMonth() + 1, 0);
    if (this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()) {
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate() + 1);
      this.loadDateData();
    }
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  public discardSaveData(): void {
    this.childModal.hide();
  }



  discardData(): void {
    this.loadMonthData();
    this.loadPlan();
  }

  validateData(): boolean {
    return true;
  }

  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this._dataService.saveGreenStickerPlan(this.greenSticPlanMonthly, _sendMail)
        .subscribe((resp: GenResponse) => {
          if (resp.status == DataService.statusFail) {
            if (resp.errorCode == DataService.staleDataCode) {
              this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
            } else {
              this._notify.error('Failure', resp.details, this._dataService.failureOptions);
            }
          }
          else {
            this._notify.success('Success', resp.details, this._dataService.successOptions);
            this.loadMonthData();
            this.loadPlan();
          }

        });
    }
  }

  public removeRecord(_tokenIndex: number) {
    this.dGSPDayTokenObj.removeToken(_tokenIndex);
    this.areChangesMade = true;
  }

  loadDateData(): void {
    let _tmpGSPDayToken: GSPDayToken = this.greenSticPlanMonthly.getDateToken(this.currMonthDtObj);
    if (_tmpGSPDayToken == null) {
      this.greenSticPlanMonthly.addDateToken(this.currMonthDtObj);
      _tmpGSPDayToken = this.greenSticPlanMonthly.getDateToken(this.currMonthDtObj);
    }
    this.dGSPDayTokenObj = _tmpGSPDayToken;
  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  shortageChanged(val) {
    if(this.isNewRecord){
      if (val == 'yes') {
        this.shortageFlag = true;
      }else{
        this.editRow.severityValue = null;
        this.editRow.shortageNotes = null;
        this.severityFlag = false;
        this.shortageFlag = false;
      }
    }else{
      if(val == 'no'){
        this.editRow.severityValue = null;
        this.editRow.shortageNotes = null;
        this.severityFlag = false;
        this.shortageFlag = false;
      }
      else if(val == 'yes' && this.prevValue == 'no'){
        this.shortageFlag = true;
      }
      else{
        this.severityFlag = true;
      }
    }
  }
  severityClicked(editRow,option){
    this.severityFlag = true;  
      this.shortageFlag = false;      
      this.editRow.severityValue = option;
     // this.loadShortageData();
  }

}
